var _circle, _path, _circle2, _path2, _g, _path3, _rect, _circle3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _rect9, _rect10, _rect11, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPopupPasswordResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 28,
    r: 7,
    fill: "#4571B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9573 61H49C49.5236 48.7614 59.6112 39 71.9787 39C84.3461 39 94.4338 48.7614 94.9573 61Z",
    fill: "#4571B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 21,
    r: 11,
    fill: "#407EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 69C72 51.3269 57.6731 37 40 37C22.3269 37 8 51.3269 8 69H72Z",
    fill: "#407EDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3921_70786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 53C24 50.7909 25.7909 49 28 49H84C86.2091 49 88 50.7909 88 53V89C88 91.2091 86.2091 93 84 93H28C25.7909 93 24 91.2091 24 89V53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 53C24.5 51.067 26.067 49.5 28 49.5H84C85.933 49.5 87.5 51.067 87.5 53V89C87.5 90.933 85.933 92.5 84 92.5H28C26.067 92.5 24.5 90.933 24.5 89V53Z",
    stroke: "#C7D6EA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 49C25.7909 49 24 50.7909 24 53V58H88V53C88 50.7909 86.2091 49 84 49H28ZM49 51C47.8954 51 47 51.8954 47 53C47 54.1046 47.8954 55 49 55H63C64.1046 55 65 54.1046 65 53C65 51.8954 64.1046 51 63 51H49Z",
    fill: "#244469"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 64,
    width: 18,
    height: 19,
    fill: "#407EDB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 69,
    r: 3,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 83C52 78.0294 47.9706 74 43 74C38.0294 74 34 78.0294 34 83H52Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 64,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 68,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 72,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 76,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 80,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 84,
    width: 19,
    height: 1,
    fill: "#7783A1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 84,
    width: 18,
    height: 1,
    fill: "#7783A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0586 36.0555C50.0268 35.4823 50.483 35 51.0571 35H60.9429C61.517 35 61.9732 35.4823 61.9414 36.0555L61.0525 52.0555C61.023 52.5854 60.5847 53 60.054 53H51.946C51.4153 53 50.977 52.5854 50.9475 52.0555L50.0586 36.0555Z",
    fill: "#7783A1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 38,
    width: 6,
    height: 1,
    fill: "#C7D6EA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 40,
    width: 6,
    height: 1,
    fill: "#C7D6EA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 42,
    width: 6,
    height: 1,
    fill: "#C7D6EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3921_70786",
    x: 22,
    y: 47,
    width: 72,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3921_70786"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3921_70786",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupPasswordResetIcon);
export default __webpack_public_path__ + "static/media/popup_password_reset_icon.39330037c43ccd114ee8353038137df6.svg";
export { ForwardRef as ReactComponent };